import { GridColDef } from "@mui/x-data-grid";
import { Icon } from "@octano/global-ui";
import dayjs from "dayjs";
import currencyFormat from "../../../../utils/currency-format";
import { CollectionTypeEquivalent } from "../../type";

export default function useColumns(): GridColDef[] {
  return [
    {
      field: "date",
      headerName: "Fecha de pago",
      type: "string",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 1,
      valueFormatter: (params: string) => {
        return dayjs(params).format("DD/MM/YYYY");
      },
    },
    {
      field: "debtOwnerIdentifier",
      headerName: "RUT Sustentador o Deudor",
      type: "string",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "debtIdToDisplay",
      headerName: "Nº Dcto",
      type: "string",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "details",
      headerName: "Detalle",
      type: "number",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "type",
      headerName: "Tipo",
      type: "string",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
      valueFormatter: (params: string) => {
        return CollectionTypeEquivalent[params];
      },
    },
    {
      field: "installment",
      headerName: "Nº Cuota",
      type: "number",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "installmentDueDate",
      headerName: "Fecha de vencimiento",
      type: "number",
      headerAlign: "center",
      align: "center",
      width: 150,
      valueFormatter: (params: string) => {
        return dayjs(params).format("DD/MM/YYYY");
      },
    },
    {
      field: "finalAmount",
      headerName: "Monto pago",
      type: "custom",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => {
        return (
          <p>
            <strong>
              {currencyFormat(params.value.value, params.value.currency)}
            </strong>
          </p>
        );
      },
    },
    {
      field: "voucher",
      headerName: "Ver comprobante",
      type: "custom",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => {
        return (
          <span onClick={() => !!params.value && window.open(params.value)}>
            <Icon
              name="file_pdf"
              color={params.value ? "primary" : "disabled"}
            />
          </span>
        );
      },
    },
  ];
}
